import { v4 as uuidv4 } from 'uuid'
import EventBus from "./eventBus"
import store from "../store/appStore"

function toBasketProduct(product) {
    return {
        id: uuidv4(),
        productId: product.id,
        name: product.name,
        preorder: product.preorder,
        inscription: undefined,
    }
}

function getBasket() {
    return JSON.parse(JSON.stringify(store.state.basket.products))
}

function addToBasket(basketProduct) {
    const basket = getBasket()
    basket.push(basketProduct)
    store.commit("setBasket", basket)

    EventBus.$emit("basket")
    EventBus.$emit("toaster", {
        message: `${basketProduct.name} a bien été ajouté à votre panier.`,
        icon: "basket",
    })
}

function removeToBasket(id) {
    const basket = getBasket()
    const newBasket = basket.filter((basketProduct) => basketProduct.id !== id)
    store.commit("setBasket", newBasket)

    EventBus.$emit("basket")
}

function emptyBasket() {
    store.commit("setBasket", [])
    EventBus.$emit("basket")
}

function setInscription(id, message) {
    const basket = getBasket()
    basket.find(product => product.id === id).inscription = message
    store.commit("setBasket", basket)

    EventBus.$emit("basket")
}

function getPromotionalCodes() {
    return JSON.parse(JSON.stringify(store.state.basket.promotionalCodes))
}

function setPromotionalCode(code) {
    const codes = getPromotionalCodes()
    const newCodes = [...codes, code]
    setPromotionalCodes(newCodes)
}

function setPromotionalCodes(codes) {
    store.commit('setPromotionalCodes', codes)
}

function emptyPromotionalCodes() {
    setPromotionalCodes([])
}

export {
    addToBasket,
    getBasket,
    toBasketProduct,
    removeToBasket,
    emptyBasket,
    setInscription,
    getPromotionalCodes,
    setPromotionalCode,
    setPromotionalCodes,
    emptyPromotionalCodes,
}